import React, { useState } from 'react';
import Onboarding from './Onboarding';
import ComingSoon from './ComingSoon';
import Assets from './Assets';

const TABS = [
  { id: 'onboarding', label: 'Onboarding' },
  { id: 'seo', label: 'SEO' },
  { id: 'ppc', label: 'PPC' },
  { id: 'social', label: 'Social Media' },
  { id: 'content', label: 'Content Calendar' },
  { id: 'local', label: 'Local / GBP' },
  { id: 'reporting', label: 'Reporting' },
  { id: 'assets', label: 'Assets' },
  { id: 'content-request', label: 'Content Requests' },
];

const COMING_SOON = {
  seo: { icon: '🔍', desc: 'Keyword tracking, on-page tasks, technical fixes, and ranking reports will live here.' },
  ppc: { icon: '🎯', desc: 'Campaign notes, budget tracking, ad performance, and landing page status will live here.' },
  social: { icon: '📱', desc: 'Post schedule, platform status, content approvals, and engagement tracking will live here.' },
  content: { icon: '📅', desc: 'Editorial calendar across all channels — blog, social, email, and paid — will live here.' },
  local: { icon: '📍', desc: 'Google Business Profile tasks, review management, citation tracking, and local rankings will live here.' },
  reporting: { icon: '📊', desc: 'Dashboard links, monthly report notes, and KPI tracking will live here.' },
  assets: { icon: '🗂️', desc: 'Brand files, login/access log, and key client contacts will live here.' },
  'content-request': { icon: '✏️', desc: 'Submit and track content requests — blog posts, social graphics, ad copy, landing pages, and more.' },
};

export default function Dashboard({ onLogout }) {
  const [activeTab, setActiveTab] = useState('onboarding');
  const [stats, setStats] = useState({ done: 1, total: 26, pct: 4 });

  const updateStats = (done, total) => {
    setStats({ done, total, pct: total ? Math.round((done / total) * 100) : 0 });
  };

  const getTabStatus = (id) => {
    if (id !== 'onboarding') return 'todo';
    if (stats.done === stats.total) return 'done';
    if (stats.done > 0) return 'inprogress';
    return 'todo';
  };

  return (
    <div style={{ background: '#111', minHeight: '100vh' }}>
      {/* Hero */}
      <div style={{ background: '#111', padding: '40px 48px 0' }}>
        <div style={{ maxWidth: 960, margin: '0 auto', display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', gap: 32, flexWrap: 'wrap' }}>
          <div>
            <h1 style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 800, fontSize: 46, lineHeight: 1, textTransform: 'uppercase', color: '#fff' }}>
              Superior Plumbing<br /><em style={{ color: '#D60000', fontStyle: 'normal' }}>Client Dashboard</em>
            </h1>
            <p style={{ marginTop: 8, fontSize: 13, color: '#aaa', letterSpacing: '0.02em' }}>PPC · SEO · Social Media · Web — Fortitude Creative</p>
          </div>
          <div style={{ display: 'flex', gap: 28, alignItems: 'flex-end' }}>
            {[
              { num: stats.done, label: 'Complete', red: true },
              { num: stats.total, label: 'Total' },
              { num: stats.pct + '%', label: 'Progress' },
            ].map(s => (
              <div key={s.label} style={{ textAlign: 'center' }}>
                <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: 38, fontWeight: 800, color: s.red ? '#D60000' : '#fff', lineHeight: 1 }}>{s.num}</div>
                <div style={{ fontSize: 10, color: '#aaa', letterSpacing: '0.1em', textTransform: 'uppercase', marginTop: 2 }}>{s.label}</div>
              </div>
            ))}
            <button onClick={onLogout} style={{ background: 'transparent', border: '1px solid #3a3a3a', borderRadius: 3, padding: '6px 12px', fontFamily: "'Barlow Condensed', sans-serif", fontSize: 11, fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', color: '#666', cursor: 'pointer' }}>Logout</button>
          </div>
        </div>
      </div>

      {/* Progress bar */}
      <div style={{ maxWidth: 960, margin: '20px auto 0', padding: '0 48px' }}>
        <div style={{ background: '#333', height: 3, borderRadius: 2 }}>
          <div style={{ height: '100%', background: '#D60000', borderRadius: 2, width: stats.pct + '%', transition: 'width 0.4s ease' }} />
        </div>
      </div>

      {/* Tabs */}
      <div style={{ maxWidth: 960, margin: '32px auto 0', padding: '0 48px' }}>
        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
          {TABS.map(tab => {
            const status = getTabStatus(tab.id);
            const isActive = activeTab === tab.id;
            const dotColor = status === 'done' ? '#1db86e' : status === 'inprogress' ? '#e6a800' : '#555';
            const textColor = status === 'done' ? '#6fcfa2' : status === 'inprogress' ? '#f0c040' : '#aaa';
            const borderColor = isActive ? '#D60000' : status === 'done' ? 'rgba(29,184,110,0.35)' : status === 'inprogress' ? 'rgba(230,168,0,0.35)' : '#3a3a3a';
            return (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                style={{
                  fontFamily: "'Barlow Condensed', sans-serif", fontSize: 13, fontWeight: 700,
                  letterSpacing: '0.1em', textTransform: 'uppercase', padding: '9px 18px',
                  borderRadius: 3, border: `1px solid ${borderColor}`,
                  background: isActive ? '#2a2a2a' : '#1e1e1e',
                  color: isActive ? '#fff' : textColor,
                  cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 7,
                  transition: 'all 0.15s ease',
                }}
              >
                <span style={{ width: 7, height: 7, borderRadius: '50%', background: dotColor, flexShrink: 0 }} />
                {tab.label}
              </button>
            );
          })}
        </div>
      </div>
      <div style={{ maxWidth: 960, margin: '0 auto', padding: '0 48px' }}>
        <div style={{ borderBottom: '2px solid #3a3a3a', marginTop: -1 }} />
      </div>

      {/* Panels */}
      {activeTab === 'onboarding' ? (
        <Onboarding onStatsChange={updateStats} />
      ) : activeTab === 'assets' ? (
        <Assets />
      ) : (
        <ComingSoon id={activeTab} icon={COMING_SOON[activeTab]?.icon} desc={COMING_SOON[activeTab]?.desc} label={TABS.find(t => t.id === activeTab)?.label} />
      )}

      {/* Footer */}
      <div style={{ background: '#1e1e1e', borderTop: '1px solid #3a3a3a', textAlign: 'center', padding: 16, fontSize: 11, color: '#444', letterSpacing: '0.08em', textTransform: 'uppercase', marginTop: 40 }}>
        <span style={{ color: '#D60000' }}>Fortitude Creative</span> · Superior Plumbing Client Dashboard · Confidential
      </div>
    </div>
  );
}
